"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _formGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/form-group.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _formGroup.default);
/** A **FormGroup** encapsulates components related to a single form input.
 * At a minimum, it should contain **FormLabel** and input child components. */

var FormGroup = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      cssNamespace = _ref.cssNamespace,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "cssNamespace"]);
  // Note that we don't want to include the fd-form-group--inline
  // class here because it is only for FormRadioGroup
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: classnames("".concat(cssNamespace, "-form-group")),
    ref: ref
  }), children);
});

FormGroup.displayName = 'FormGroup';
process.env.NODE_ENV !== "production" ? FormGroup.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node
} : void 0;

var _default = (0, _withStyles.default)(FormGroup);

exports.default = _default;